import clsx from "clsx";
import type { ReactNode } from "react";

import { Section, type SectionProps } from "@widgets/section";

import { ButtonWithIcon } from "@shared/ui/button-with-icon";
import type { IconNameType } from "@shared/ui/icon";
import { Heading } from "@shared/ui/typography";

import s from "./other-points-section.module.scss";

export type OtherPointsSectionProps = Omit<SectionProps, "children"> & {
  title: string;
  children: ReactNode;
  buttonHref: string;
  buttonText: string;
  buttonIconName: IconNameType;
  buttonFillColor?: string;
  cardsClassName?: string;
};

export const OtherPointsSection = (props: OtherPointsSectionProps) => {
  const {
    className,
    title,
    children,
    buttonHref,
    buttonText,
    buttonIconName,
    buttonFillColor = "cadmium",
    cardsClassName,
    ...rest
  } = props;

  return (
    <Section
      className={clsx(s.root, s.otherObjectsContainer, className)}
      {...rest}
    >
      <Heading level={3}>{title}</Heading>
      <div className={s.cardsContainer}>
        <div className={clsx(cardsClassName, { [s.cards]: !cardsClassName })}>
          {children}
        </div>
        <ButtonWithIcon
          href={buttonHref}
          className={s.button}
          variant="primary-dark"
          iconName={buttonIconName}
          iconFillColor={buttonFillColor}
          iconStrokeColor="white"
        >
          {buttonText}
        </ButtonWithIcon>
      </div>
    </Section>
  );
};

OtherPointsSection.displayName = "OtherPointsSection";
